import { useMemo } from 'react';
import {
	resolveTrendChartCompareUi,
	resolveTrendChartFilters,
	resolveTrendChartSaveFilters,
	TREND_CHART_FILTER_MODE,
} from '../lib/resolveTrendChartFilters';

/**
 * 趋势图 filters 会话：页级 applied / 编辑器 overlay 的 chart、query、save、对比 UI 口径。
 */
const useTrendChartFilterSession = ({
	mode = TREND_CHART_FILTER_MODE.PAGE_APPLIED,
	applied = {},
	draft = {},
} = {}) =>
	useMemo(() => {
		const chartFilters = resolveTrendChartFilters({ mode, applied, draft });
		const compareUi = resolveTrendChartCompareUi({ mode, applied, draft });
		const saveFilters = resolveTrendChartSaveFilters({ applied, draft });
		return { chartFilters, compareUi, saveFilters };
	}, [applied, draft, mode]);

export default useTrendChartFilterSession;
